module.exports = __webpack_public_path__ + "img/wx.be0f6e1b.jpg";